/*
  getDefaultSettings.js
*/

// Lib.
import getUserPrefersDarkMode from './getUserPrefersDarkMode';

/**
 * Gets default settings for the force-graph.
 */
export default function getDefaultSettings() {

  return {
    isDark: getUserPrefersDarkMode(),
    arrows: 1,        // 0 = off, (1, 2, 3..) = size.
    particles: 0,     // 0 = off, (1, 2, 3..) = size.
    nodeLabels: 2,    // 0 = off, 1 = hover, 2 = on.
    linkLabels: 1,    // 0 = off, 1 = hover, 2 = on.
    physics: 0,       // 0 = off, 1 = some, 2 = strong.
  };

}
